import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Wind, Instagram, Youtube, Github } from 'lucide-react';

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-white/10 bg-[#0A0A0A] mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <Wind className="w-6 h-6 text-[#00B4D8]" />
              <span className="font-display text-2xl">KITEIQ</span>
            </div>
            <p className="text-sm text-muted-foreground mt-3 max-w-xs">{t('footer.tagline')}</p>
          </div>
          <div>
            <h4 className="label-eyebrow text-muted-foreground mb-3">{t('footer.product')}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/analyze" className="hover:text-[#48CAE4]">{t('footer.analyzeSession')}</Link></li>
              <li><Link to="/spots" className="hover:text-[#48CAE4]">{t('footer.spotMap')}</Link></li>
              <li><Link to="/pricing" className="hover:text-[#48CAE4]">{t('footer.pricing')}</Link></li>
              <li><Link to="/dashboard" className="hover:text-[#48CAE4]">{t('footer.dashboard')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="label-eyebrow text-muted-foreground mb-3">{t('footer.company')}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><span className="hover:text-[#48CAE4] cursor-pointer">{t('footer.about')}</span></li>
              <li><span className="hover:text-[#48CAE4] cursor-pointer">{t('footer.privacy')}</span></li>
              <li><span className="hover:text-[#48CAE4] cursor-pointer">{t('footer.terms')}</span></li>
            </ul>
          </div>
          <div>
            <h4 className="label-eyebrow text-muted-foreground mb-3">{t('footer.follow')}</h4>
            <div className="flex gap-3">
              <Instagram className="w-5 h-5 text-muted-foreground hover:text-[#48CAE4] cursor-pointer" />
              <Youtube className="w-5 h-5 text-muted-foreground hover:text-[#48CAE4] cursor-pointer" />
              <Github className="w-5 h-5 text-muted-foreground hover:text-[#48CAE4] cursor-pointer" />
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 text-xs text-muted-foreground flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} {t('footer.copyright')}</span>
          <span>{t('footer.poweredBy')}</span>
        </div>
      </div>
    </footer>
  );
};
